// Environment variables
export const API_BASE_DEFAULT = process.env.REACT_APP_API_BASE || '';
export const PROJECT_ID = process.env.REACT_APP_PROJECT_ID || '';

// Storage keys
export const STORAGE_FILES = 'atlas-ide:v2:files';
export const STORAGE_WORKING = 'atlas-ide:v2:working';
export const STORAGE_TABS = 'atlas-ide:v2:tabs';
export const STORAGE_ACTIVE = 'atlas-ide:v2:active-tab';
export const STORAGE_PROJECT = 'atlas-ide:v2:active-project';
export const STORAGE_PROJECTS = 'atlas-ide:v2:projects';
export const STORAGE_BRANCH = 'atlas-ide:v2:branch';
export const STORAGE_AUTOSAVE = 'atlas-ide:v2:autosave';
export const STORAGE_PREFIX = 'atlas-ide:v2';
export const STORAGE_LOGS = 'atlas-ide:v2:logs';
export const STORAGE_API_BASE = 'atlas-ide:v2:api-base';
export const STORAGE_API_KEY = 'atlas-ide:v2:api-key';
export const STORAGE_API_SECRET = 'atlas-ide:v2:api-secret';
export const STORAGE_THEME = 'atlas-ide:v2:theme';

// Preview HTML template
export const PREVIEW_HTML_TEMPLATE = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <style>
    body { margin: 0; font-family: system-ui, sans-serif; background: #0f172a; color: #e2e8f0; }
    #root { padding: 16px; }
  </style>
</head>
<body>
  <div id="root"></div>
  <script>
    // Console forwarding to parent window
    (function() {
      const methods = ['log', 'warn', 'error', 'info', 'debug'];
      const originalConsole = {};

      methods.forEach(function(method) {
        originalConsole[method] = console[method];
        console[method] = function() {
          // Call original console method
          originalConsole[method].apply(console, arguments);

          // Serialize arguments
          const args = Array.from(arguments).map(function(arg) {
            if (arg === null) return 'null';
            if (arg === undefined) return 'undefined';
            if (typeof arg === 'object') {
              try {
                return JSON.stringify(arg, null, 2);
              } catch (e) {
                return String(arg);
              }
            }
            return String(arg);
          });

          // Send to parent
          try {
            window.parent.postMessage({
              type: 'preview-console',
              method: method,
              args: args,
              timestamp: Date.now()
            }, '*');
          } catch (e) {
            // Ignore errors
          }
        };
      });

      // Also catch errors
      window.onerror = function(message, source, lineno, colno, error) {
        try {
          window.parent.postMessage({
            type: 'preview-console',
            method: 'error',
            args: ['Error: ' + message + ' at line ' + lineno + ':' + colno],
            timestamp: Date.now()
          }, '*');
        } catch (e) {}
      };

      // Catch unhandled promise rejections
      window.onunhandledrejection = function(event) {
        try {
          window.parent.postMessage({
            type: 'preview-console',
            method: 'error',
            args: ['Unhandled Promise Rejection: ' + (event.reason ? event.reason.message || String(event.reason) : 'Unknown')],
            timestamp: Date.now()
          }, '*');
        } catch (e) {}
      };
    })();

    // Network request interception
    (function() {
      var requestId = 0;
      var originalFetch = window.fetch;

      // Intercept fetch
      window.fetch = function(input, init) {
        var id = ++requestId;
        var url = typeof input === 'string' ? input : input.url;
        var method = (init && init.method) || 'GET';
        var startTime = Date.now();

        // Notify parent of request start
        try {
          window.parent.postMessage({
            type: 'preview-network',
            event: 'request',
            id: id,
            url: url,
            method: method,
            headers: init && init.headers ? Object.fromEntries(new Headers(init.headers)) : {},
            body: init && init.body ? String(init.body).slice(0, 1000) : null,
            timestamp: startTime
          }, '*');
        } catch (e) {}

        return originalFetch.apply(this, arguments).then(function(response) {
          var duration = Date.now() - startTime;

          // Clone response to read body
          var cloned = response.clone();
          cloned.text().then(function(body) {
            try {
              window.parent.postMessage({
                type: 'preview-network',
                event: 'response',
                id: id,
                url: url,
                method: method,
                status: response.status,
                statusText: response.statusText,
                headers: Object.fromEntries(response.headers),
                body: body.slice(0, 2000),
                duration: duration,
                timestamp: Date.now()
              }, '*');
            } catch (e) {}
          }).catch(function() {});

          return response;
        }).catch(function(error) {
          var duration = Date.now() - startTime;
          try {
            window.parent.postMessage({
              type: 'preview-network',
              event: 'error',
              id: id,
              url: url,
              method: method,
              error: error.message,
              duration: duration,
              timestamp: Date.now()
            }, '*');
          } catch (e) {}
          throw error;
        });
      };

      // Intercept XMLHttpRequest
      var originalXHR = window.XMLHttpRequest;
      window.XMLHttpRequest = function() {
        var xhr = new originalXHR();
        var id = ++requestId;
        var method = 'GET';
        var url = '';
        var startTime;

        var originalOpen = xhr.open;
        xhr.open = function(m, u) {
          method = m;
          url = u;
          return originalOpen.apply(xhr, arguments);
        };

        var originalSend = xhr.send;
        xhr.send = function(body) {
          startTime = Date.now();

          try {
            window.parent.postMessage({
              type: 'preview-network',
              event: 'request',
              id: id,
              url: url,
              method: method,
              body: body ? String(body).slice(0, 1000) : null,
              timestamp: startTime
            }, '*');
          } catch (e) {}

          return originalSend.apply(xhr, arguments);
        };

        xhr.addEventListener('load', function() {
          var duration = Date.now() - startTime;
          try {
            window.parent.postMessage({
              type: 'preview-network',
              event: 'response',
              id: id,
              url: url,
              method: method,
              status: xhr.status,
              statusText: xhr.statusText,
              body: xhr.responseText ? xhr.responseText.slice(0, 2000) : null,
              duration: duration,
              timestamp: Date.now()
            }, '*');
          } catch (e) {}
        });

        xhr.addEventListener('error', function() {
          var duration = Date.now() - startTime;
          try {
            window.parent.postMessage({
              type: 'preview-network',
              event: 'error',
              id: id,
              url: url,
              method: method,
              error: 'Network error',
              duration: duration,
              timestamp: Date.now()
            }, '*');
          } catch (e) {}
        });

        return xhr;
      };
    })();

    // Touch simulation listener
    (function() {
      window.addEventListener('message', function(event) {
        if (!event.data || event.data.type !== 'touch-simulation') return;

        var eventType = event.data.eventType;
        var touches = event.data.touches || [];

        // Create touch objects
        var touchList = touches.map(function(t) {
          return new Touch({
            identifier: t.identifier,
            target: document.elementFromPoint(t.clientX, t.clientY) || document.body,
            clientX: t.clientX,
            clientY: t.clientY,
            pageX: t.pageX,
            pageY: t.pageY,
            screenX: t.screenX,
            screenY: t.screenY
          });
        });

        // Find the target element
        var target = document.body;
        if (touches.length > 0) {
          var elem = document.elementFromPoint(touches[0].clientX, touches[0].clientY);
          if (elem) target = elem;
        }

        // Create and dispatch touch event
        try {
          var touchEvent = new TouchEvent(eventType, {
            bubbles: true,
            cancelable: true,
            touches: touchList,
            targetTouches: touchList,
            changedTouches: touchList
          });
          target.dispatchEvent(touchEvent);

          // Also dispatch corresponding mouse events for compatibility
          if (eventType === 'touchstart') {
            var mouseDown = new MouseEvent('mousedown', {
              bubbles: true,
              clientX: touches[0].clientX,
              clientY: touches[0].clientY
            });
            target.dispatchEvent(mouseDown);
          } else if (eventType === 'touchmove') {
            var mouseMove = new MouseEvent('mousemove', {
              bubbles: true,
              clientX: touches[0].clientX,
              clientY: touches[0].clientY
            });
            target.dispatchEvent(mouseMove);
          } else if (eventType === 'touchend') {
            var mouseUp = new MouseEvent('mouseup', { bubbles: true });
            target.dispatchEvent(mouseUp);
            var click = new MouseEvent('click', {
              bubbles: true,
              clientX: touches[0].clientX,
              clientY: touches[0].clientY
            });
            target.dispatchEvent(click);
          }
        } catch (e) {
          // TouchEvent constructor not supported, use mouse events
          if (eventType === 'touchstart' && touches.length > 0) {
            var mouseDown = new MouseEvent('mousedown', {
              bubbles: true,
              clientX: touches[0].clientX,
              clientY: touches[0].clientY
            });
            target.dispatchEvent(mouseDown);
          }
        }
      });
    })();
  </script>
  <script type="module">
    import React from 'https://esm.sh/react@18.3.1';
    import ReactDOM from 'https://esm.sh/react-dom@18.3.1/client';
    import App from 'APP_BUNDLE_URL';
    const root = document.getElementById('root');
    ReactDOM.createRoot(root).render(React.createElement(App));
  </script>
</body>
</html>`;

// Seed data
export const steps = [
  { title: 'Create the React workspace', detail: 'Set up Vite or CRA with TypeScript.', status: 'done' },
  { title: 'Design the IDE shell', detail: 'Explorer, editor, live preview, console.', status: 'done' },
  { title: 'Wire Monaco or CodeMirror', detail: 'Embed a code editor with TS support.', status: 'done' },
  { title: 'Add sandboxed preview', detail: 'Render output with an iframe sandbox.', status: 'todo' },
  { title: 'Connect commands', detail: 'Run lint/test/build tasks from UI.', status: 'todo' },
];

export const commitHistorySeed = [
  {
    id: '603b9e8',
    message: 'Add commit input + styles',
    author: 'you',
    date: '2025-12-03 09:40',
    summary: 'Added commit form to header; log commit action.',
    diff: [
      " src/App.tsx | +25 -2",
      " src/App.css | +22 -0",
      "+ Added commit message input and button",
      "+ Styled commit box container",
      "- Placeholder text only before",
    ],
  },
  {
    id: '10af65e',
    message: 'Multi-project workspace selector',
    author: 'you',
    date: '2025-12-03 09:20',
    summary: 'Project dropdown with per-project cache and requests.',
    diff: [
      " src/App.tsx | +48 -12",
      " src/App.css | +10 -0",
      "+ Cache now scoped per project",
      "+ Active project select in header",
    ],
  },
  {
    id: '4067862',
    message: 'Polish live preview controls',
    author: 'you',
    date: '2025-12-03 09:05',
    summary: 'Better buttons and iframe restart.',
    diff: [
      " src/App.tsx | +12 -6",
      " src/App.css | +8 -0",
      "+ Added restart/sandbox toggles",
      "+ Restyled preview controls",
    ],
  },
];
